import styled from 'styled-components';
import { constants, Paragraph } from '@cambridgeassessment/cambridge-ui';

const StyledParagraph = styled(Paragraph)`
  font-size: ${constants.MEDIUM};
`;

const BoldParagraph = styled(StyledParagraph)`
  font-weight: 600;
  margin-top: 0;
`;

export { BoldParagraph, StyledParagraph };
